<!-- <div class="text-left">
    <ul>
        <li *ngFor="let o of notifications"><a href="#">{{o.notification_Details}}</a></li>
    </ul>
</div> -->

<a *ngFor="let o of notifications" class="dropdown-item fs-12" href="#">{{ o.notification_Details }}</a>